/**
 *  Constants for Occupancy Trend Modal
 */

export const doubleDash = '\u2014\u2014';
